export default __webpack_public_path__ + "static/media/RoutePage2.b7fa6e8a.txt";